module.exports = JSON.parse('{"Copied":"تم النسخ","Failed to copy":"فشل النسخ"}')